import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Office as Desc } from './desk'
import { Office as Mob } from './mob'

type Props = {
  images: TImages
}
export const Office: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
